import { createFetchActions, createWebSocketReceiveActions } from './createFetchActions';

const fetchMediaListActions = createFetchActions('FETCH_MEDIA_LIST');
const saveMediaActions = createFetchActions('SAVE_MEDIA');
const deleteMediaActions = createFetchActions('DELETE_MEDIA');
const uploadLargeMediaActions = createFetchActions('UPLOAD_LARGE_MEDIA');
const mediaUpdateActions = createWebSocketReceiveActions('MEDIA_UPDATE');

export { fetchMediaListActions, saveMediaActions, deleteMediaActions, uploadLargeMediaActions, mediaUpdateActions };
